import { useEffect, useState, useRef } from 'react';
import { Tooltip } from '@arkestro/arkestro-design-system';
import styles from './WithTruncatedTooltip.module.scss';

interface TruncatedTooltipProps {
  minWidth?: number;
  name: string;
  style?: string;
}

// TODO: Move this component to ADS
export const WithTruncatedTooltip = ({ name, minWidth = 300, style = styles.truncatedText }: TruncatedTooltipProps) => {
  const [isTruncated, setIsTruncated] = useState(false);
  const titleRef = useRef(null);

  const resizeObserver = new ResizeObserver(
    (entries: ResizeObserverEntry[]) => {
      entries.forEach(entry => {
        const target = entry.target as HTMLElement;
        const { offsetWidth, scrollWidth } = target;

        setIsTruncated(offsetWidth < scrollWidth);
      });
    }
  );

  const tooltipText = isTruncated ? name : undefined;

  useEffect(() => {
    if (titleRef.current) {
      resizeObserver.observe(titleRef.current);
    }
  }, [titleRef]);

  return <Tooltip overlayStyle={{ minWidth }} title={tooltipText}>
    <span ref={titleRef} className={style}>{name}</span>
  </Tooltip>;
};
